export default __webpack_public_path__ + "static/how_to_save_on_fees_when_shopping_on_overseas_websites-9636523846ac9598c042e5b0e799e109.jpg";